export enum TypeMaintenanceSchedulingEnums {
    //Tipo de programación
    horometro = 1,
    dia = 2
}

export enum StateMaintenanceSchedulingDetailEnums {
    //Estados de programación detalle
    optimo = 1,
    programado = 2,
    atrasado = 3
}